<template>
  <keep-alive :include ="includes">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
import api from '@/utils/api/appoint'
import {mapGetters, mapMutations} from 'vuex'
export default {
  components: {},
  name: 'ProjectAppointDetail',
  props: {},
  data() {
    return {
      includes: [],
    }
  },
  watch: {},
  computed: {
    ...mapGetters('form', ['getFormData'])
  },
  methods: {
    ...mapMutations('form', ['setFormConfig', 'setFormType','removeRid']),
    fetchComponentConfig() {
      api
        .getComponentConfig()
        .then(res => {
          //添加data字段
          // debugger
          this.removeRid()
          const data = this.setCommonFormFinal(res.data)
          // debugger
          this.setFormConfig(data)
          //  this.$store.state.formConfig = data
          for (let i = 0; i < res.length; i++) {
            if (res[i].isShow) {
              this.componentName = res[i].componentName
              this.$router.push({name: this.componentName})
              break
            }
          }
        })
        .catch(err => {
          this.$toast.fail('请求错误')
          this.$router.go(-1)
        })
    },
    setCommonFormFinal(res) {
      let data = res
      data.forEach(item => {
        //CommonFormFinal的数据是列表来的
        if (item.componentName == 'CommonFormFinal') {
          for (let key in this.getFormData) {
            item.data[key] = this.getFormData[key]
          }
          item.data['JSXZ'] = '新建'
          item.data['XZQ'] = ''
        }
      })
      return data
    }
  },
  created() {},
  mounted() {
    //带id是在材料上传请求,to，带上confirm，是从确认信息界面跳回来
    if(!this.$route.params.id&&this.$route.params.to!='confirm'){
      this.fetchComponentConfig()
    }
  },
  
}
</script>
<style lang="scss" scoped></style>
